<template>
  <ASelectLocale
    v-if="i18n.locales.value.length > 1"
    v-model="uiLocale"
    :options="i18n.locales.value"
  />
</template>

<script lang="ts" setup>
const i18n = useI18n()
const { activeLocaleTypes, uiLocale } = storeToRefs(useLocaleStore())
activeLocaleTypes.value.add('ui')
</script>
